import React from 'react';
import { CalculatorIcon, ClipboardListIcon, LineChartIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const bonuses = [{
  n: '01',
  icon: CalculatorIcon,
  title: 'Calculadora para cuidar tu plata',
  text: 'Una forma simple de decidir cuánto poner y cuánto reservar antes de dar un paso.'
}, {
  n: '02',
  icon: ClipboardListIcon,
  title: 'Plan de acción de 0 a buen inversor en 21 días',
  text: 'Una guía de aprendizaje día por día para entender y aplicar el método. No promete ganancias en 21 días.'
}, {
  n: '03',
  icon: LineChartIcon,
  title: 'Casos reales explicados',
  text: '5 ejemplos desglosados para ver decisiones, aciertos y cosas para mejorar.'
}];
export function BonusSection() {
  return <Section className="bg-ink-950" data-id="element-18" data-mp="r08220uabsap">
      <Reveal data-id="element-19" data-mp="qz5bxv4sdtvu">
        <span className="text-sm font-semibold uppercase tracking-widest text-brand" data-id="element-20" data-mp="qywyo24r4mk4">Incluido con tu acceso</span>
        <h2 className="mt-3 font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-21" data-mp="mws7rb5ou416">
          3 bonos para empezar con un camino claro
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-22" data-mp="2ep3b9x8p965z">
        {bonuses.map((bonus, index) => {
        const Icon = bonus.icon;
        return <Reveal key={bonus.n} delay={index * 0.08} data-id="element-23" data-mp="2ofxwcya7lzpu" data-mpi={index}>
              <div className="group h-full rounded-2xl border border-white/10 bg-ink-900 p-6 transition-colors hover:border-brand/40" data-id="element-24" data-mp="1qt8nc4h3amuh">
                <div className="flex items-center justify-between" data-id="element-25" data-mp="1vtd4lwptnllr">
                  <span className="font-display text-3xl font-extrabold text-white/10" data-id="element-26" data-mp="20roeg7g49w3z">{bonus.n}</span>
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-soft" data-id="element-27" data-mp="25q83igq0bo0k">
                    <Icon className="h-5 w-5 text-brand" data-id="element-28" data-mp="3c73an90i4jy1" />
                  </span>
                </div>
                <h3 className="mt-5 font-display text-base font-bold text-white" data-id="element-29" data-mp="3h552ojfwntln">
                  <span aria-hidden="true" data-id="element-30" data-mp="1h359bss4klvq">🎁</span> {bonus.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-31" data-mp="1h58an8yqa1fr">{bonus.text}</p>
              </div>
            </Reveal>;
      })}
      </div>
    </Section>;
}